import { NotificationActionType } from "../notification"
import { NotificationActionService } from "../NotificationActionService"

function handleAutomationNotification(data?: any) {
  console.log('Handling automation notification', data)
}

function dispatchReconnectModalOpenEvent(data?: any) {
  window.dispatchEvent(new CustomEvent('customEvent_reconnect'))
}

async function dispatchNotificationForConnectionsWithDeletedCalendars(data?: any, store?: any) {
  const locationId = store?.state?.locations?.currentLocation?.id
  const userId = store?.state?.user?.user?.id
  
  window.dispatchEvent(new CustomEvent('customEvent_removeDeletedCalendars', {
    detail: {
      locationId,
      userId
    }
  }))
}

export function registerAutomationNotificationActions(store: any) {
  NotificationActionService.registerAction(NotificationActionType.TestNotification, handleAutomationNotification)
  NotificationActionService.registerAction(NotificationActionType.ShowReconnectModal, dispatchReconnectModalOpenEvent)
  NotificationActionService.registerAction(
    NotificationActionType.ConnectionsWithDeletedCalendars, 
    (data) => dispatchNotificationForConnectionsWithDeletedCalendars(data, store)
  )
}
